module.exports = __webpack_public_path__ + "static/media/img-mission-first.d0d8968d.webp";